import { Button, ButtonProps } from 'antd';
import classNames from 'classnames';
import { forwardRef } from 'react';

type ButtonType = 'primary' | 'secondary' | 'text' | 'tertiary';

interface MButtonProps extends Omit<ButtonProps, 'type'> {
  type?: ButtonType;
}

const MButton = forwardRef<HTMLButtonElement, MButtonProps>((props, ref) => {
  switch (props.type) {
    case 'secondary':
      return (
        <Button
          ref={ref}
          {...(props as ButtonProps)}
          className={classNames(
            'trojan-button ant-btn-secondary',
            props.className
          )}
          type="default"
        />
      );
    case 'tertiary':
      return (
        <Button
          ref={ref}
          {...(props as ButtonProps)}
          className={classNames(
            'trojan-button ant-btn-tertiary',
            props.className
          )}
          type="default"
        />
      );
    case 'text':
      return (
        <Button
          ref={ref}
          {...(props as ButtonProps)}
          className={classNames('trojan-button ant-btn-text', props.className)}
          type="default"
        />
      );
    default:
      return (
        <Button
          ref={ref}
          {...(props as ButtonProps)}
          className={classNames('trojan-button', props.className)}
        />
      );
  }
});

export default MButton;
